import './agenda-block.scss';
export default () => {
  $('.js-agenda-items').click(function (e) {
    e.preventDefault();
    $(this).hide();
    $('.agenda-block__items').removeClass('hide');
  });
};